export enum FullFeedbackAlertType {
    Success,
    Info,
    Question,
    Warning,
    Error
}
